/**
 * Collection card: show Add to cart first; after successful add (or if variant already in cart),
 * show quantity selector that syncs cart via /cart/update.js (same pattern as bulk quick add).
 */
(function () {
  /** Same event key as constants.js / pubsub — string avoids cross-script const scope issues. */
  var CARD_CART_UPDATE = 'cart-update';

  function qtyForVariant(cartData, variantId) {
    if (!cartData || variantId == null) return 0;
    const vid = parseInt(variantId, 10);
    if (Number.isNaN(vid)) return 0;
    const items = cartData.items || cartData.cart?.items;
    if (!items || !items.length) return 0;
    const item = items.find(function (i) {
      return parseInt(i.variant_id, 10) === vid;
    });
    return item ? parseInt(item.quantity, 10) || 0 : 0;
  }

  function revealCardsForVariant(variantId, qty) {
    if (qty < 1) return;
    var vid = String(variantId);
    document.querySelectorAll('[data-card-atc] .product-variant-id').forEach(function (hiddenInput) {
      if (String(hiddenInput.value) !== vid) return;
      var cardAtc = hiddenInput.closest('[data-card-atc]');
      if (!cardAtc) return;
      applyPhaseFromCartQty(cardAtc, qty);
      bindCartQtyUpdates(cardAtc);
    });
  }

  function fetchCartAndReveal(variantId) {
    var url = typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url + '.js' : '/cart.js';
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var qty = qtyForVariant(cart, variantId);
        revealCardsForVariant(variantId, qty);
      })
      .catch(function () {});
  }

  function getQtyInput(root) {
    return root.querySelector('[data-card-qty-input]');
  }

  function syncQtyInputFromVariantOption(input, optionEl) {
    if (!input || !optionEl) return;
    const vid = optionEl.value;
    const min = parseInt(optionEl.dataset.qtyMin || '1', 10);
    const step = parseInt(optionEl.dataset.qtyStep || '1', 10);
    input.dataset.index = vid;
    input.name = 'updates[' + vid + ']';
    input.min = '0';
    input.dataset.min = String(min);
    input.step = String(step);
    if (optionEl.dataset.qtyMax !== undefined && optionEl.dataset.qtyMax !== '') {
      input.max = optionEl.dataset.qtyMax;
      input.dataset.max = optionEl.dataset.qtyMax;
    } else {
      input.removeAttribute('max');
      delete input.dataset.max;
    }
  }

  function applyPhaseFromCartQty(cardAtc, qty) {
    const phaseAdd = cardAtc.querySelector('.card-quick-add__phase-add');
    const phaseQty = cardAtc.querySelector('.card-quick-add__phase-qty');
    const input = getQtyInput(cardAtc);
    if (!phaseAdd || !phaseQty) return;

    if (qty > 0) {
      phaseAdd.setAttribute('hidden', '');
      phaseQty.removeAttribute('hidden');
      if (input) {
        input.value = String(qty);
        input.setAttribute('value', String(qty));
      }
      const qi = input?.closest('quantity-input');
      if (qi && typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
    } else {
      phaseQty.setAttribute('hidden', '');
      phaseAdd.removeAttribute('hidden');
      if (input) {
        input.value = '0';
        input.setAttribute('value', '0');
      }
    }
  }

  /** Sync every product card ATC UI with current cart (e.g. after remove in cart drawer). */
  function syncAllCardsFromCart(cartData) {
    if (!cartData) return;

    document.querySelectorAll('[data-card-atc]').forEach(function (cardAtc) {
      const hiddenInput = cardAtc.querySelector('.product-variant-id');
      if (!hiddenInput) return;

      const qty = qtyForVariant(cartData, hiddenInput.value);
      applyPhaseFromCartQty(cardAtc, qty);
      if (qty > 0) bindCartQtyUpdates(cardAtc);
    });
  }

  function refreshAllCardsFromCart() {
    const url = typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url + '.js' : '/cart.js';
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(syncAllCardsFromCart)
      .catch(function () {});
  }

  function bindCartQtyUpdates(cardAtc) {
    if (cardAtc.dataset.cartQtyBound === 'true') return;
    cardAtc.dataset.cartQtyBound = 'true';

    const debounced = debounce(function (event) {
      const target = event.target;
      if (!target || !target.matches('[data-card-qty-input]')) return;

      const variantId = target.dataset.index;
      const raw = parseInt(target.value, 10);

      if (raw === 0) {
        target.setCustomValidity('');
        sendCartUpdate(cardAtc, variantId, 0);
        return;
      }

      const minRule = parseInt(target.dataset.min || '1', 10);
      if (raw < minRule) {
        target.setCustomValidity(window.quickOrderListStrings.min_error.replace('[min]', target.dataset.min));
        target.reportValidity();
        resetInput(target);
        return;
      }
      if (target.max && raw > parseInt(target.max, 10)) {
        target.setCustomValidity(window.quickOrderListStrings.max_error.replace('[max]', target.max));
        target.reportValidity();
        resetInput(target);
        return;
      }
      if (raw % parseInt(target.step || '1', 10) !== 0) {
        target.setCustomValidity(window.quickOrderListStrings.step_error.replace('[step]', target.step));
        target.reportValidity();
        resetInput(target);
        return;
      }

      target.setCustomValidity('');
      target.reportValidity();
      target.setAttribute('value', raw);
      sendCartUpdate(cardAtc, variantId, raw);
    }, typeof ON_CHANGE_DEBOUNCE_TIMER !== 'undefined' ? ON_CHANGE_DEBOUNCE_TIMER : 300);

    cardAtc.addEventListener('change', debounced);
  }

  function resetInput(input) {
    const v = input.getAttribute('value');
    if (v != null) input.value = v;
  }

  function sendCartUpdate(cardAtc, variantId, quantity) {
    const payload = {
      updates: { [parseInt(variantId, 10)]: quantity },
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    };

    fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript'), body: JSON.stringify(payload) })
      .then((response) => response.text())
      .then((text) => {
        const parsed = JSON.parse(text);
        publish(CARD_CART_UPDATE, { source: 'card-product-qty', cartData: parsed });
        const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cartUi && parsed.sections && typeof cartUi.renderContents === 'function') {
          try {
            cartUi.renderContents(parsed);
          } catch (e) {
            console.warn(e);
          }
        }
        const q = qtyForVariant(parsed, variantId);
        if (q === 0) {
          applyPhaseFromCartQty(cardAtc, 0);
        } else {
          const input = getQtyInput(cardAtc);
          if (input) {
            input.value = String(q);
            input.setAttribute('value', String(q));
            const qi = input.closest('quantity-input');
            if (qi && typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
          }
        }
      })
      .catch((e) => console.error(e));
  }

  function revealAfterProductFormAdd(variantId, cartData) {
    var qty = qtyForVariant(cartData, variantId);
    if (qty >= 1) {
      revealCardsForVariant(variantId, qty);
      return;
    }
    /* Add-to-cart JSON sometimes omits items when sections are bundled — refresh qty from /cart.js */
    fetchCartAndReveal(variantId);
  }

  function initCard(cardAtc) {
    const initial = parseInt(cardAtc.dataset.initialQty || '0', 10);
    if (initial > 0) {
      bindCartQtyUpdates(cardAtc);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-card-atc]').forEach(initCard);
  });

  if (typeof subscribe === 'function') {
    subscribe(CARD_CART_UPDATE, function (event) {
      if (!event) return;

      if (event.source === 'product-form' && event.productVariantId != null) {
        revealAfterProductFormAdd(String(event.productVariantId), event.cartData);
        return;
      }

      /* Cart drawer / cart page remove or qty change — restore Add to cart on cards */
      if (event.cartData) {
        syncAllCardsFromCart(event.cartData);
      }
    });
  }

  document.addEventListener('cart:updated', refreshAllCardsFromCart);

  /* If pubsub missed the event (script order), still reveal after add once cart UI finishes */
  document.addEventListener(
    'product-form:added',
    function (e) {
      var d = e.detail || {};
      if (d.variantId != null) {
        revealAfterProductFormAdd(String(d.variantId), d.cartData || {});
      }
    },
    true
  );

  document.addEventListener('product-card:variant-change', (e) => {
    const { productId, variantId } = e.detail || {};
    if (!productId || !variantId) return;

    fetch(`${typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : '/cart'}.js`)
      .then((r) => r.json())
      .then((cart) => {
        const qty =
          cart.items?.find((i) => String(i.variant_id) === String(variantId))?.quantity || 0;

        document.querySelectorAll(`[data-product-id="${productId}"] [data-card-atc]`).forEach((cardAtc) => {
          const host = cardAtc.closest('[data-product-id]') || cardAtc;
          const dropdown = host.querySelector('.product-option-dropdown, .variant-dropdown');
          const opt = dropdown?.querySelector(`option[value="${variantId}"]`);
          const input = getQtyInput(cardAtc);
          if (input && opt) syncQtyInputFromVariantOption(input, opt);
          applyPhaseFromCartQty(cardAtc, qty);
          if (qty > 0) bindCartQtyUpdates(cardAtc);
        });
      })
      .catch((err) => console.error(err));
  });
})();
